'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CatalogRegistrationRemote = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _helpers = require('./helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CatalogRegistrationRemote = exports.CatalogRegistrationRemote = {
    fetchCatalogRegistration: function fetchCatalogRegistration(_ref) {
        var authToken = _ref.authToken,
            catalogId = _ref.catalogId,
            deployment = _ref.deployment,
            email = _ref.email;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<CLERK-SERVICE>clerk/approval/' + catalogId, deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.send({
                AuctionId: catalogId,
                Email: email,
                Token: authToken
            });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response, success404: true });
            });
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/remote/catalogRegistration.js
// module id = yTM5
// module chunks = 57